import {
  SizeModifierMap,
  AnimationModifierMap,
  RotationModifierMap,
  FlipModifierMap,
} from "@/types/Icon"

export const SIZE_CLASSES: SizeModifierMap = {
  sm: { fontSize: "18px", height: "18px", width: "18px" },
  md: { fontSize: "24px", height: "24px", width: "24px" },
  lg: { fontSize: "36px", height: "36px", width: "36px" },
  xlg: { fontSize: "48px", height: "48px", width: "48px" },
}

export const ANIMATION_CLASSES: AnimationModifierMap = {
  spin: {
    animation: "spin 2s linear infinite",
  },
  "spin-reverse": {
    animation: "spin-reverse 2s linear infinite",
  },
}

export const ROTATION_CLASSES: RotationModifierMap = {
  "rotate-45": { transform: "rotate(45deg)" },
  "rotate-90": { transform: "rotate(90deg)" },
  "rotate-135": { transform: "rotate(135deg)" },
  "rotate-180": { transform: "rotate(180deg)" },
  "rotate-225": { transform: "rotate(225deg)" },
  "rotate-270": { transform: "rotate(270deg)" },
  "rotate-315": { transform: "rotate(315deg)" },
}

export const FLIP_CLASSES: FlipModifierMap = {
  "flip-h": { transform: "scaleX(-1)" },
  "flip-v": { transform: "scaleY(-1)" },
}
